import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const PackagesFilter = ({
    clientPackages = [],
    loading = false,
    filters = {},
    restoreFilterValues,
}) => (
    <Field
        className='medium'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='clientPackages'
        placeholder='Package'
        options={clientPackages}
        search
        setValue={restoreFilterValues(filters, 'clientPackages')}
    />
);

PackagesFilter.propTypes = {
    clientPackages: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object,
    restoreFilterValues: PropTypes.func.isRequired,
};
